// extracted by mini-css-extract-plugin
export default {"modal":"styles_modal__vNxu3","modalDialog":"styles_modalDialog__4nEf2","modalContent":"styles_modalContent__ZddkZ","title":"styles_title__3yOh+"};